import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { ISubCategoryContext, SubCategoryContext } from '../../subCategoryState/subCategoryContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './SubCategories.module.scss';

const SubCategories: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, subCategories, currentPage, countOfItems } =
		useContext<ISubCategoryContext>(SubCategoryContext);

	return (
		<>
			{subCategories.subCategoriesCount ? (
				<div className={style.container} data-test="SubCategories">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={subCategories.subCategoriesCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default SubCategories;
